import { MeshBasicMaterial } from 'three'
import { useColumnsMeshes } from '~/components/DrawingCanvas/Columns/hooks/useColumnsMeshes'
import { isMeshWithGeometry } from '~/components/DrawingCanvas/Products/util'
import { UNIT_CONVERSION_SCALAR } from '~/components/DrawingCanvas/util/units'
import theme from '~/config/theme'
import { useAppSelector } from '~/store/hooks'

const columnsMaterial = new MeshBasicMaterial({ color: theme.colors.three.objects.roofSection.column.default })

export const Columns = () => {
  const columnsMeshes = useColumnsMeshes()
  const isVisible = useAppSelector(state => state.layers.layers.COLUMNS.visible)
  return (
    <group scale={1 / UNIT_CONVERSION_SCALAR} visible={isVisible}>
      {columnsMeshes.map(([id, mesh]) => {
        if (!mesh) return
        mesh.children.forEach(child => {
          if (isMeshWithGeometry(child)) child.material = columnsMaterial
        })
        return (
          <group key={id}>
            <primitive object={mesh} />
          </group>
        )
      })}
    </group>
  )
}
